import React from 'react'
import { useTranslation } from 'react-i18next'
// import LanguageToggle from '../components/LanguageToggle'

function DesktopScreen() {
  const { t } = useTranslation()
  return (
    <>
  <meta charSet="UTF-8" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, maximum-scale=1"
  />
  {/*=============== FAVICON ===============*/}
  <link
    rel="shortcut icon"
    href="assets/images/favicon.ico"
    type="image/x-icon"
  />
  {/*=============== LINK TO EXTERNAL CSS ===============*/}
  <link rel="stylesheet" href="assets/css/styles.css?ver=1.7" />
  <title>Thirukkural | Britannia </title>
  <div className="page-wrapper">
    <div className="main-wrapper">
      {/*=============== DESKTOP SCREEN START ===============*/}
      <div className="d-frame-outer desktop-only">
        <img src="assets/images/desktop-star.webp" className="d-frame-star-bg" />
        {/* corners */}
        <span className="d-frame-corner tl" />
        <span className="d-frame-corner tr" />
        <span className="d-frame-corner bl" />
        <span className="d-frame-corner br" />
        <div className="d-frame-border-outer">
          <div className="d-frame-border">
            <div className="d-frame-border-inner">
              <div className="d-frame-canvas">
                {/* CONTENT */}
                <div className="d-frame-content">
                  {/* Your desktop screen content here */}
                  <div className="desktop-center">
                    <div className="desktop-content-box">
                      <h3>
                        {t("common.desktopInterest")}
                      </h3>
                      <img
                        src="assets/images/desktop-logo-milk-bikis.webp"
                        className="desktop-logo"
                        alt="Milk Bikis Logo"
                      />
                      <div className="desktop-qr-box">
                        {/* CORNERS */}
                        <span className="qr-corner qr-corner-tl" />
                        <span className="qr-corner qr-corner-tr" />
                        <span className="qr-corner qr-corner-bl" />
                        <span className="qr-corner qr-corner-br" />
                        {/* CONTENT */}
                        <div className="qr-left">
                          <p className="qr-text">
                            {t("common.desktopQr")}
                          </p>
                        </div>
                        <div className="qr-right">
                          <img
                            src="assets/images/desktop-qr.svg"
                            alt="QR Code"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*=============== DESKTOP SCREEN END ===============*/}
      {/* ══ PERSISTENT FRAME ══ */}
      <div className="frame-outer mobile-only">
        {/* <LanguageToggle className="kuran-lang-switch--floating" /> */}
        {/* orange corners sit at frame-outer edges */}
        <span className="frame-corner tl" />
        <span className="frame-corner tr" />
        <span className="frame-corner bl" />
        <span className="frame-corner br" />
        {/* black outer → green → black inner → blue canvas */}
        <div className="frame-border-outer">
          <div className="frame-border">
            <div className="frame-border-inner">
              <div className="frame-canvas">
                <img
                  className="frame-bg-image"
                  src="assets/images/star-bg.webp"
                  alt="Star Element"
                />
                {/* SPLASH */}
                <div id="splash" className="frame-content">
                  {/* Lottie renders here */}
                </div>
                {/* LANGUAGE SELECT POPUP */}
                <div
                  id="lang-select"
                  className="frame-content"
                  style={{ display: "none" }}
                >
                  {/* Background splash content image */}
                  <img
                    src="assets/images/splash-content.webp"
                    className="lang-bg-image"
                    alt="Splash Content"
                  />
                  <div className="lang-screen">
                    <div className="lang-scroll-wrap">
                      <div className="lang-scroll">
                        <div className="lang-scroll-inner">
                          <img
                            src="assets/images/language-popup-bg.webp"
                            className="img-fit"
                            alt="Language Background"
                          />
                          <p className="lang-heading">
                            Choose your
                            <br /> language
                          </p>
                          <div className="lang-options">
                            <label className="lang-option">
                              <input
                                type="radio"
                                name="language"
                                defaultValue="ta"
                                className="lang-radio"
                              />
                              <span className="lang-radio-custom" />
                              <span className="lang-label">தமிழ்</span>
                            </label>
                            <label className="lang-option">
                              <input
                                type="radio"
                                name="language"
                                defaultValue="en"
                                className="lang-radio"
                              />
                              <span className="lang-radio-custom" />
                              <span className="lang-label">English</span>
                            </label>
                          </div>
                        </div>
                        {/* Bottom banner with version text + Okay button */}
                        <div className="lang-scroll-footer">
                          {/* Submit Button */}
                          <button
                            className="btn-next"
                            type="button"
                            id="langOkayBtn"
                          >
                            <span>Okay</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* MAIN */}
                <div
                  id="main"
                  className="frame-content"
                  style={{ display: "none" }}
                >
                  {/* SIGN UP SCREEN START */}
                  <div className="signup-screen">
                    {/* top header */}
                    <div className="signup-header">
                      <img
                        src="assets/images/milk-bikis-logo.webp"
                        alt="Britannia Milk Bikis"
                        className="signup-logo"
                      />
                      <img
                        src="assets/images/sign-up-head-text.webp"
                        alt="திருக்குறள் சேலஞ்ச்"
                        className="signup-title-img"
                      />
                    </div>
                    {/* scrollable form body */}
                    <div className="signup-body">
                      <h2 className="signup-heading text-center">SIGN UP</h2>
                      <p className="signup-subtext">
                        Complete Kurals and
                        <br />
                        win rewards with MBK!
                      </p>
                      <form
                        className="signup-form"
                        id="signupForm"
                        action="otp.html"
                      >
                        {/* Name */}
                        <div className="form-field">
                          <input
                            type="text"
                            placeholder="Name"
                            className="form-input"
                          />
                        </div>
                        {/* Phone Number */}
                        <div
                          className="form-field input-with-icon"
                          id="phoneField"
                        >
                          <input
                            type="tel"
                            placeholder="Phone Number"
                            className="form-input"
                            id="phone"
                            maxLength={13}
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            inputMode="numeric"
                            name="no-autofill-phone-2"
                            readOnly=""
                            onfocus="this.removeAttribute('readonly');"
                          />
                          <span className="error-text">
                            Enter valid phone number
                          </span>
                          <span className="error-icon">!</span>
                        </div>
                        {/* State Dropdown */}
                        <div className="form-field">
                          <div className="form-select-wrap">
                            <select className="form-input form-select">
                              <option value="" disabled="" selected="">
                                State
                              </option>
                              {/* States */}
                              <option>Andhra Pradesh</option>
                              <option>Arunachal Pradesh</option>
                              <option>Assam</option>
                              <option>Bihar</option>
                              <option>Chhattisgarh</option>
                              <option>Goa</option>
                              <option>Gujarat</option>
                              <option>Haryana</option>
                              <option>Himachal Pradesh</option>
                              <option>Jharkhand</option>
                              <option>Karnataka</option>
                              <option>Kerala</option>
                              <option>Madhya Pradesh</option>
                              <option>Maharashtra</option>
                              <option>Manipur</option>
                              <option>Meghalaya</option>
                              <option>Mizoram</option>
                              <option>Nagaland</option>
                              <option>Odisha</option>
                              <option>Punjab</option>
                              <option>Rajasthan</option>
                              <option>Sikkim</option>
                              <option>Tamil Nadu</option>
                              <option>Telangana</option>
                              <option>Tripura</option>
                              <option>Uttar Pradesh</option>
                              <option>Uttarakhand</option>
                              <option>West Bengal</option>
                              {/* Union Territories */}
                              <option>Andaman and Nicobar Islands</option>
                              <option>Chandigarh</option>
                              <option>
                                Dadra and Nagar Haveli and Daman and Diu
                              </option>
                              <option>Delhi</option>
                              <option>Jammu and Kashmir</option>
                              <option>Ladakh</option>
                              <option>Lakshadweep</option>
                              <option>Puducherry</option>
                            </select>
                            {/* Dropdown Arrow */}
                            <span className="select-arrow">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={16}
                                height={16}
                                viewBox="0 0 44 44"
                                fill="none"
                              >
                                <path
                                  d="M35.1185 16.2085L21.6114 29.7156L8.10425 16.2085"
                                  stroke="black"
                                  strokeWidth="4.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                        {/* Checkbox */}
                        <div className="form-checkbox-row">
                          <input
                            type="checkbox"
                            id="agree"
                            className="form-checkbox"
                            required=""
                          />
                          <label
                            htmlFor="agree"
                            className="form-checkbox-label"
                          >
                            By signing up you agree to our
                            <br />
                            <a href="/tnc">{t("common.terms")}</a> {t("common.and")} <a href="/privacy-policy">{t("common.privacy")}</a>
                          </label>
                        </div>
                        {/* reCAPTCHA */}
                        <div className="form-field recaptcha-field">
                          <div className="recaptcha-placeholder">reCAPTCHA</div>
                        </div>
                        {/* Submit Button */}
                        <button className="btn-next" type="submit">
                          <span>Next</span>
                        </button>
                        {/* Login */}
                        <p className="signup-login">
                          Already registered? <a href="/login">{t("common.login")}</a>
                        </p>
                      </form>
                    </div>
                  </div>
                  {/* SIGN UP SCREEN END */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer absolutely at bottom of frame-outer */}
        <div className="frame-footer">
          <div className="frame-footer-pill">
            {/* Instagram */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={48}
              height={48}
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M13.7205 0H33.5916C41.1616 0 47.3122 6.15058 47.3122 13.7205V33.5916C47.3122 37.2306 45.8666 40.7204 43.2935 43.2935C40.7204 45.8666 37.2306 47.3122 33.5916 47.3122H13.7205C6.15058 47.3122 0 41.1616 0 33.5916V13.7205C0 10.0816 1.44555 6.59175 4.01865 4.01865C6.59175 1.44555 10.0816 0 13.7205 0ZM13.2474 4.73122C10.9888 4.73122 8.82265 5.62846 7.22555 7.22555C5.62846 8.82265 4.73122 10.9888 4.73122 13.2474V34.0648C4.73122 38.7723 8.53985 42.581 13.2474 42.581H34.0648C36.3234 42.581 38.4895 41.6837 40.0866 40.0866C41.6837 38.4895 42.581 36.3234 42.581 34.0648V13.2474C42.581 8.53985 38.7723 4.73122 34.0648 4.73122H13.2474ZM36.0755 8.27963C36.8598 8.27963 37.6119 8.59117 38.1665 9.14572C38.721 9.70027 39.0325 10.4524 39.0325 11.2366C39.0325 12.0209 38.721 12.773 38.1665 13.3276C37.6119 13.8821 36.8598 14.1937 36.0755 14.1937C35.2913 14.1937 34.5392 13.8821 33.9846 13.3276C33.4301 12.773 33.1185 12.0209 33.1185 11.2366C33.1185 10.4524 33.4301 9.70027 33.9846 9.14572C34.5392 8.59117 35.2913 8.27963 36.0755 8.27963ZM23.6561 11.828C26.7931 11.828 29.8016 13.0742 32.0198 15.2924C34.238 17.5106 35.4841 20.5191 35.4841 23.6561C35.4841 26.7931 34.238 29.8016 32.0198 32.0198C29.8016 34.238 26.7931 35.4841 23.6561 35.4841C20.5191 35.4841 17.5106 34.238 15.2924 32.0198C13.0742 29.8016 11.828 26.7931 11.828 23.6561C11.828 20.5191 13.0742 17.5106 15.2924 15.2924C17.5106 13.0742 20.5191 11.828 23.6561 11.828ZM23.6561 16.5593C21.7739 16.5593 19.9688 17.307 18.6379 18.6379C17.307 19.9688 16.5593 21.7739 16.5593 23.6561C16.5593 25.5383 17.307 27.3434 18.6379 28.6743C19.9688 30.0052 21.7739 30.7529 23.6561 30.7529C25.5383 30.7529 27.3434 30.0052 28.6743 28.6743C30.0052 27.3434 30.7529 25.5383 30.7529 23.6561C30.7529 21.7739 30.0052 19.9688 28.6743 18.6379C27.3434 17.307 25.5383 16.5593 23.6561 16.5593Z"
                fill="black"
              />
            </svg>
            {/* X */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={48}
              height={43}
              viewBox="0 0 48 43"
              fill="none"
            >
              <path
                d="M37.2603 0H44.5148L28.6653 18.1166L47.3122 42.7643H32.7124L21.2786 27.8136L8.19289 42.7643H0.934415L17.8879 23.386L0 0.00197143H14.9704L25.3061 13.6673L37.2603 0ZM34.7153 38.4234H38.7349L12.7861 4.11419H8.47282L34.7153 38.4234Z"
                fill="black"
              />
            </svg>
            {/* Facebook */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={48}
              height={47}
              viewBox="0 0 48 47"
              fill="none"
            >
              <path
                d="M47.3122 23.3666C47.3122 10.4682 36.7142 0 23.6561 0C10.5979 0 0 10.4682 0 23.3666C0 34.6761 8.13769 44.0928 18.9249 46.2659V30.3766H14.1937V23.3666H18.9249V17.525C18.9249 13.0152 22.6389 9.34665 27.2045 9.34665H33.1185V16.3566H28.3873C27.0862 16.3566 26.0217 17.4081 26.0217 18.6933V23.3666H33.1185V30.3766H26.0217V46.6164C37.968 45.4481 47.3122 35.4939 47.3122 23.3666Z"
                fill="black"
              />
            </svg>
          </div>
          <p className="frame-footer-terms">
            <a href="/tnc">{t("common.terms")}</a> {t("common.and")} <a href="/privacy-policy">{t("common.privacy")}</a>
          </p>
        </div>
      </div>
      {/* /frame-outer */}
    </div>
  </div>
  {/*=============== LINK TO LOTTIE ANIMATION JS ===============*/}
  {/*=============== LINK TO EXTERNAL JS ===============*/}
</>

  )
}

export default DesktopScreen
